<template>
	<div class="tabbarMask">
		<div class="tabbar"></div>
		<div class="circle"></div>
		<div class="content flex flex-align-center flex-jus-around">
			<router-link :to="{name:'home'}" tag="div" class="content-bar flex flex-column align-items-center">
				<img src="@/static/images/tabbar/tabbar-home.png" class="icon" v-if="tabbar == 0">
				<img src="@/static/images/tabbar/tabbar-home-no.png" class="icon" v-else>
				<span>首页</span>
			</router-link>
			<router-link :to="{name:'friends'}" tag="div" class="content-bar flex flex-column align-items-center">
				<img src="@/static/images/tabbar/tabbar-friend.png" class="icon" v-if="tabbar == 1">
				<img src="@/static/images/tabbar/tabbar-friend-no.png" class="icon" v-else>
				<span>友圈</span>
			</router-link>
			<router-link :to="{name:'publish'}" tag="div" class="content-center">
				<img src="@/static/images/tabbar/tabbar-add.png" alt="">
			</router-link>

			<router-link :to="{name:'musicHall'}" tag="div" class="content-bar flex flex-column align-items-center">
				<img src="@/static/images/tabbar/tabbar-music.png" class="icon" v-if="tabbar == 3">
				<img src="@/static/images/tabbar/tabbar-music-no.png" class="icon" v-else>
				<span>乐堂</span>
			</router-link>
			<router-link :to="{name:'my'}" tag="div" class="content-bar flex flex-column align-items-center">
				<img src="@/static/images/tabbar/tabbar-my.png" class="icon" v-if="tabbar == 4">
				<img src="@/static/images/tabbar/tabbar-my-no.png" class="icon" v-else>
				<span>我的</span>
			</router-link>
		</div>
	</div>
	
</template>

<script>
	export default {
		props: {
			tabbar: {
				default: 0,
				type: Number
			}
		},
		data() {
			return {
				
			}
		},

		methods: {
			
		},
	}
</script>

<style lang="stylus" scoped>
.tabbarMask
	position fixed
	bottom 0
	left 0
	width 100vw
	height 100px
	background-color #FFFFFF
	z-index 100000
	.tabbar
		position absolute
		bottom 0
		left 0
		width 100%
		height 100%
		box-shadow: 0px -6px 24px rgba(0, 0, 0, 0.1);
	.circle
		position absolute
		left calc(50% - 55px)
		top -30.5px
		width 110px
		height 50px
		border-radius 110px 110px 0 0
		background-color #FFFFFF
		box-shadow: 0px -6px 24px rgba(0, 0, 0, 0.1);
	.content
		position absolute
		bottom 0
		left 0
		width 100%
		height 100%
		z-index 5
		.content-center
			width 88px
			height 88px
			margin-top -40px
			background-color #FFFFFF
			img
				width 100%
				height 100%
		.content-bar
			font-size: 24px;
			color: #B1B1B1;
			.icon
				width 44px
				height 44px
				margin-bottom 4px
				
</style>
